module.exports = __webpack_public_path__ + "media/images/homepage/bg-about-8945b704ce4d7f8f59d2b42f32182873.jpeg";